import {
  constants,
  typographyStyles as Typography,
  cssVariableStyles,
} from "@newsela/angelou";

const { generateIconColorCss } = cssVariableStyles;
const { ui } = constants.colors;
const { heading6Obj } = Typography;

const whiteColor = ui.white[50];

// z-index 1 is used by bookmark and caret buttons
// z-index 2 is used by this popover
const ASSIGN_CARET_ZINDEX = 1;
const ASSIGN_POPOVER_ZINDEX = 2;

export const assignContainerCss = {
  alignItems: "center",
  display: "flex",
};

export const ellipsisCss = {
  position: "absolute",
  height: "28px",
  margin: "10px",
  "& > *": {
    fill: "white",
  },
};

export const assignButtonCss = {
  root: {
    a: [
      {
        color: "inherit",
        paddingLeft: 0,
        textDecoration: "none",
      },
      heading6Obj,
    ],
    borderRadius: 0,
    color: ui.core[500],
    ":hover, :focus, :focus-within": {
      backgroundColor: ui.core[500],
      color: ui.white[500],
    },
  },
};

const blueCarat = generateIconColorCss({ primaryColor: ui.core[600] });
export const dropdownCaretCss = {
  ...blueCarat,
  color: ui.core[600],
  display: "block",
  width: "14.75px",
  zIndex: ASSIGN_CARET_ZINDEX,
  borderRadius: 0,
  stroke: "transparent",
};

export const horizontalDotsCss = {
  root: {
    backgroundColor: ui.core[500],
    height: "14px",
    width: "8.75px",
    zIndex: ASSIGN_CARET_ZINDEX,
    borderRadius: 0,
    ":hover, :focus, :focus-within": {
      backgroundColor: ui.core[500],
      color: ui.white[500],
    },
  },
};

export const assignButtonPopout = {
  backgroundColor: whiteColor,
  zIndex: ASSIGN_POPOVER_ZINDEX,
};

export const disabledButtonCss = {
  root: {
    opacity: 0.4,
    zIndex: 1,
    cursor: "default",
    "&:hover:not([disabled])::before": {
      backgroundColor: "unset",
    },
  },
};
